import React, { useRef, useState } from 'react';
import axios from 'axios';
import "./TeamBio.css";
import flashMessage from '../HelperFunctions';


function TeamBio({ organization, onChange }) {
  const [isSaving, setIsSaving] = useState(false);  // State to handle "saving..." message
  const placeholderText = `Tell your AI receptionist about you or your team.`;

  const typingTimer = useRef(null);
  const servicesInputRef = useRef(null);

  const handleSave = async () => {
    setIsSaving(true);  // Set the "saving..." message to show

    const inputText = servicesInputRef.current.value; // Get input directly from the element

    const jwt_token = localStorage.getItem('jwt_authorization');

    try {
      const response = await axios.put(`${process.env.REACT_APP_BACKEND_HOST}/user`, {
        staff_bio: inputText,
        jwt_token,
      });
      flashMessage('success', 'Team bio updated successfully!')
    } catch (error) {
      console.error('Failed to update:', error);
    }

    setIsSaving(false);
  };

  const handleInputChange = (e) => {
    onChange(e.target.value);
  };

  return (

    <div style={{  }}  className="customize-ai-section">
    <span>
      About Your Team
    </span>
      <textarea
        data-say-id="knowledge-base-about-team"
        ref={servicesInputRef}
        className="team-bio-text"
        placeholder={placeholderText}
        defaultValue={organization.staff_bio}
        onChange={handleInputChange}
      />

    </div>

  );
}

export default TeamBio
